const ROTATOR_SELECTOR = "[data-homepage-intro-rotator]";
const TRACK_SELECTOR = "[data-homepage-intro-track]";
const WINDOW_SELECTOR = ".cms-homepage-intro__rotator-window";
const DEFAULT_INTERVAL_MS = 2800;
const NORMAL_TRANSITION_MS = 600;
const FAST_RESET_TRANSITION_MS = 1000;

function prefersReducedMotion() {
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}

function getWordHeight(track) {
  const firstWord = track.querySelector(".cms-homepage-intro__rotator-word");
  return firstWord ? firstWord.offsetHeight : 48;
}

function setFixedWindowWidth(rotatorWindow, words) {
  const maxWidth = Math.max(
    ...Array.from(words, (word) => word.offsetWidth),
  );
  rotatorWindow.style.width = `${maxWidth}px`;
}

function initRotator(rotator) {
  const track = rotator.querySelector(TRACK_SELECTOR);
  const rotatorWindow = rotator.querySelector(WINDOW_SELECTOR);
  if (!track || !rotatorWindow) {
    return;
  }

  const words = track.querySelectorAll(".cms-homepage-intro__rotator-word");
  if (words.length <= 1 || prefersReducedMotion()) {
    setFixedWindowWidth(rotatorWindow, words);
    return;
  }

  setFixedWindowWidth(rotatorWindow, words);

  const intervalMs = Number(rotator.dataset.interval) || DEFAULT_INTERVAL_MS;
  let index = 0;
  let isResetting = false;

  const moveToIndex = (nextIndex, transitionMs) => {
    track.style.transition = `transform ${transitionMs}ms ease-in-out`;
    track.style.transform = `translateY(-${nextIndex * getWordHeight(track)}px)`;
  };

  const advance = () => {
    if (isResetting) {
      return;
    }

    if (index >= words.length - 1) {
      isResetting = true;
      moveToIndex(0, FAST_RESET_TRANSITION_MS);

      const onResetComplete = (event) => {
        if (event.propertyName !== "transform") {
          return;
        }

        track.removeEventListener("transitionend", onResetComplete);
        index = 0;
        isResetting = false;
        track.style.transition = `transform ${NORMAL_TRANSITION_MS}ms ease-in-out`;
      };

      track.addEventListener("transitionend", onResetComplete);
      return;
    }

    index += 1;
    moveToIndex(index, NORMAL_TRANSITION_MS);
  };

  track.style.transition = `transform ${NORMAL_TRANSITION_MS}ms ease-in-out`;
  window.setInterval(advance, intervalMs);
}

export function initHomepageIntroRotators() {
  document.querySelectorAll(ROTATOR_SELECTOR).forEach(initRotator);
}
